import { apiUtils } from '../utils/apiUtils'

export default {
  get: function (clientid) {
    return fetch(apiUtils.integrationModel + '?clientId=' + clientid, {
      method: 'GET',
    }).then((res) => {
      if (res.status === 200) {
        return res.json().then((data) => {
          if (data.error) return ''
          return data
        })
      }
      return ''
    })
  },
  set: function (model) {
    return fetch(apiUtils.integrationModel, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(model)
    }).then((res) => {
      if (res.status === 200) return res.json()
      return Promise.reject(new Error('Erreur lors de la création du modèle'))
    })
  }
}
